export default __webpack_public_path__ + "static/media/female-disabled.0816e409.svg";